export default class DebugInfoUtil {
  public static generateContentfulEntryLink(spaceId: string, entryId: string, environment: string) {
    return `https://app.contentful.com/spaces/${spaceId}/environments/${environment}/entries/${entryId}`
  }
}
